import { createStore } from "devextreme-aspnet-data-nojquery";
import {
  setupRequestAsync
} from "~/utils";
import { squireApiConfig } from "~/config";

const { url } = squireApiConfig;

export class AccountsPayablePageApiService {
  getAccountsPayableDataSource() {
    return createStore({
      key: "purchaseInvoiceId",
      loadUrl: `${url}/v1/accounts-payable/`,
      updateUrl: `${url}/v1/accounts-payable/make-payment`,
      onBeforeSend: async (method, ajaxOptions) =>
        await setupRequestAsync(method, ajaxOptions),
    });
  }

  getAllocationsDataSource(invoiceId) {
    return createStore({
      key: "id",
      loadUrl: `${url}/v1/accounts-payable/${invoiceId}/allocations`,
      onBeforeSend: async (method, ajaxOptions) =>
        await setupRequestAsync(method, ajaxOptions),
    });
  }
}